import { JobTitleField as DesignJobTitleField } from "@studio-features/meta-crew/job-title";

/**
 * 직책 입력 (2026-10-21 사용자: 직책은 역할(권한)과 다르다). 시안 4893fae 의 JobTitleField 를 쓴다
 * (선택 안 함 / 기본 12개 / 직접 입력 50자). 폼 안에 두면 FormData 의 jobTitle 로 값이 들어간다 (빈 값 = 직책 없음).
 */
export function JobTitleField({ defaultValue = "" }: { defaultValue?: string | null }) {
  return <DesignJobTitleField defaultValue={defaultValue ?? ""} />;
}

/** FormData 의 직책 (빈 값은 undefined → 보내지 않음). 수정 폼은 "" 를 보내 지운다. */
export const jobTitleOf = (d: FormData): string => String(d.get("jobTitle") ?? "").trim();
